<template>
    <div class="one-to-many-titan-form form-list" :class="{'disabled-form': disabled}">
        <div v-if="items.length === 0 && disabled === true">{{noItems}}</div>
        <div class="row form-list-row" v-for="(item, index) in items">
            <div class="col-sm-12 form-list-row-header">
                <template v-if="disabled === false">
                    <button type="button"
                            class="btn btn-danger btn-icon"
                            v-if="acceptAction === false"
                            @click="removeItem(index)"
                    >
                        <font-awesome-icon icon="minus"/>
                    </button>
                    <accept-action class="btn-modal-icon"
                                   buttonClass="btn-danger btn-icon"
                                   buttonIcon="minus"
                                   :buttonName="acceptModalButton"
                                   :modalText="acceptModalText"
                                   v-if="acceptAction === true"
                                   @accepted="removeItem(index)"
                    />
                </template>
                <div @click="toggleForm(index)" :class="{'c-pointer': ! disabled}">
                    <slot :name="schema.model + '-item-header'"  v-bind:item="item">
                        {{ item[schema.listModel] }}
                    </slot>
                </div>
            </div>
            <div class="col-sm-12 form-list-row-body" :class="{'d-none': index !== openedForm}">
                <div class="form-container">
                    <vue-form-generator :schema="{fields: schema.fields}"
                                        :ref="'newItemForm-' + index"
                                        :model="item"
                                        :options="formOptions"
                    />
                </div>
            </div>
        </div>
        <template v-if="disabled === false">
            <div class="row form-list-row" v-if="showNewItem === true">
                <div class="col-sm-12 form-list-row-header">
                    <button type="button"
                            class="btn btn-danger btn-icon"
                            @click="showNewItem = false; setNewModel()"
                            v-if="acceptAction === false"
                    >
                        <font-awesome-icon icon="minus"/>
                    </button>
                    <accept-action class="btn-modal-icon"
                                   buttonClass="btn-danger btn-icon"
                                   buttonIcon="minus"
                                   :buttonName="acceptModalButton"
                                   :modalText="acceptModalText"
                                   v-if="acceptAction === true"
                                   @accepted="showNewItem = false; setNewModel()"
                    />
                    <span>{{newItemLabel}}</span>
                </div>
                <div class="col-sm-12 form-list-row-body">
                    <div class="form-container">
                        <vue-form-generator :schema="{fields: schema.fields}"
                                            ref="newItemForm"
                                            :model="newModel"
                                            :options="formOptions"
                        />
                        <button type="button" class="btn-success btn btn-sm" @click="addItem()">
                            <font-awesome-icon icon="plus"/>
                            <span>{{addItemLabel}}</span>
                        </button>
                        <button type="button"
                                class="btn-outline-secondary btn btn-sm"
                                @click="showNewItem = false; setNewModel()"
                        >
                            <font-awesome-icon icon="times"/>
                            <span>{{closeAddItemLabel}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <button type="button"
                    class="btn-success btn btn-sm"
                    @click="showNewItem = true"
                    v-if="showNewItem === false && editable === true"
            >
                <font-awesome-icon icon="plus"/>
                <span>{{addItemLabel}}</span>
            </button>
        </template>
    </div>
</template>
<script>
  import VueFormGenerator from 'vue-form-generator'
  import AcceptAction from '../AcceptAction'
  import { get, has, set } from 'lodash'

  export default {
        components: {
            AcceptAction,
            'vue-form-generator': VueFormGenerator.component,
        },
        props: {
            model: {
                type: Object,
                required: true,
            },
            schema: {
                type: Object,
                required: true,
            },
            editable: {
                type: Boolean,
                required: false,
                'default': true
            }
        },
        mounted() {
            console.log(this.schema.model + '-item-header');
          this.setNewModel();
            if (false === has(this.model, this.schema.model)) {
              set(this.model, this.schema.model, []);
            }
            // if (this.model[this.schema.model] === undefined) {
            //     this.model[this.schema.model] = [];
            // }
        },
        watch: {
            blockedNewForm: {
                handler(newValue) {
                    this.blockedNewForm = false;
                },
                deep: true,
            }
        },
        computed: {
            closeAddItemLabel() {
                return this.schema.closeAddItemLabel === undefined
                    ? this.t('Close add item')
                    : this.schema.closeAddItemLabel;
            },
            addItemLabel() {
                return this.schema.addItemLabel === undefined
                    ? this.t('Add item')
                    : this.schema.addItemLabel;
            },
            acceptModalText() {
                return this.schema.acceptModalText === undefined
                    ? this.t('Do you want to delete item?')
                    : this.schema.acceptModalText;
            },
            newItemLabel() {
                return this.schema.newItemLabel === undefined
                    ? this.t('New item')
                    : this.schema.newItemLabel;
            },
            acceptModalButton() {
                return this.schema.acceptModalButton === undefined
                    ? this.t('Delete item')
                    : this.schema.acceptModalButton;
            },
            noItems() {
                return this.schema.acceptModalButton === undefined
                    ? this.t('Items are not available')
                    : this.schema.acceptModalButton;
            },
            acceptAction() {
                return this.schema.acceptAction === undefined ? false : this.schema.acceptAction;
            },
            disabled() {
                return this.schema.disabled === undefined ? false : this.schema.disabled;
            },
            items() {
              return get(this.model, this.schema.model, []);
                // return this.model[this.schema.model] === undefined ? [] : this.model[this.schema.model];
            },
            minValues() {
                return this.schema.min === undefined ? 0 : this.schema.min;
            }
        },
        methods: {
            isValid() {
                let valid = true;
                this.items.forEach((item, index) => {
                    const itemFormComponent = this.$refs['newItemForm-' + index];
                    if (itemFormComponent !== undefined && this.validForm(itemFormComponent[0]) === false) {
                        valid = false;
                        this.openedForm = index;
                    }
                });
                this.addItem();
                /*if (this.minValues > 0) {
                    return this.items.length > this.schema.min;
                }*/
                return valid;
            },
            toggleForm(index) {
                if (this.disabled) {
                  return;
                }
                this.openedForm = this.openedForm === index ? null : index;
            },
            addItem() {
                if (this.$refs.newItemForm !== undefined
                    && this.validForm(this.$refs.newItemForm) === true
                    && this.blockedNewForm === false
                ) {
                    const data = get(this.model, this.schema.model, []);
                    data.push(this.newModel);
                    set(this.model, this.schema.model, data)
                    // this.model[this.schema.model].push(this.newModel);
                    this.showNewItem = false; // todo: mozno nastavitelne
                    this.blockedNewForm = true;
                    this.setNewModel();
                }
            },
            validForm(formRef) {
                formRef.validate();
                return formRef.errors.length === 0;
            },
            removeItem(index) {
                this.openedForm = null;

                const data = get(this.model, this.schema.model, []);
                data.splice(index);
                set(this.model, this.schema.model, data)
                // this.model[this.schema.model].splice(index, 1);
            },
            setNewModel() {
                const model = {};
                this.schema.fields.forEach(item => {
                    model[item.model] = item.default === undefined ? null : item.default;
                    if (item.codeBook !== undefined) {
                        const codeBookData = this.$store.getters['codeBook/get'](item.codeBook);
                        const defaultCodeBookValue = codeBookData.find(res => {
                            return res.id === model[item.model];
                        });
                        model[item.model] = defaultCodeBookValue !== undefined ? defaultCodeBookValue : null;
                    }
                });
                this.newModel = model;
            }
        },
        data() {
            return {
                openedForm: null,
                showNewItem: false,
                blockedNewForm: false,
                newModel: {},
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        }
    }
</script>
<style lang="scss">
    .one-to-many-titan-form {
        &.disabled-form {
            .form-list-row-header {
                padding-left: 10px ! important;
            }

            .form-list-row-body {
                padding-left: 10px ! important;
            }

            .form-list-row {
                &:last-child {
                    border-bottom: 0;
                    margin-bottom: 0;
                    padding-bottom: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/core/Form/OneToMany.vue